export default __webpack_public_path__ + "static/wheelsDesktop-22d4c7b2aca92208ec841369c638004f.webp";